import React from "react";
import { useTranslation } from "react-i18next";
import ToggleInput from "@/components/ui/ToggleInput";

const TopCitationCompetitorsHeader = ({
  isOwnDomainOnly,
  setIsOwnDomainOnly,
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="text-sm fw-medium text-dark">
        {t("dashboard.topCitationCompetitors", "Top Citation Competitors")}
      </div>
      <ToggleInput
        label={t("dashboard.ownDomainOnly", "Own Domain Only")}
        checked={isOwnDomainOnly}
        onChange={(e) => setIsOwnDomainOnly(e.target.checked)}
      />
    </div>
  );
};

export default TopCitationCompetitorsHeader;
